import {
	RET_ENABLING_CHECKS
} from '../actions/RETFilesUploadActions.js';

const initialState = {
	remove: []
};

const RETFilesUploadReducer = (state = initialState, action) => {
	switch (action.type) {
					case RET_ENABLING_CHECKS: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default RETFilesUploadReducer;
